import { Assembly } from '@/__generated__/graphql';
import { ArrowUpward } from '@mui/icons-material';
import { Fade, Tooltip } from '@mui/material';
import InfiniteLoader from 'react-window-infinite-loader';
import { useComponentsListData } from '../hooks/useComponentsListData';
import { FloatingButton, ScrollContainer, StyledList } from './styles';

export const ComponentsList = ({
  components = [],
  totalComponents = 0,
  loadMore,
}: {
  components: Partial<Assembly>[];
  totalComponents: number;
  loadMore: () => void;
}) => {
  const {
    containerRef,
    listRef,
    isItemLoaded,
    itemCount,
    Row,
    handleScrollToTop,
    handleScroll,
    isAtScrollStart,
    containerHeight,
    containerWidth,
    itemSize,
  } = useComponentsListData({ components, totalComponents });

  return (
    <ScrollContainer ref={containerRef}>
      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        itemCount={itemCount}
        threshold={10}
        loadMoreItems={loadMore}
      >
        {({ onItemsRendered, ...props }) => {
          return (
            <StyledList
              key={`${containerHeight}-${containerWidth}`}
              height={containerHeight}
              itemCount={itemCount}
              itemSize={itemSize}
              onItemsRendered={onItemsRendered}
              onScroll={handleScroll}
              width={'100%'}
              {...props}
              ref={listRef}
            >
              {Row}
            </StyledList>
          );
        }}
      </InfiniteLoader>
      <Fade in={!isAtScrollStart}>
        <Tooltip title="Scroll to Top" placement="top" arrow>
          <FloatingButton onClick={handleScrollToTop}>
            <ArrowUpward />
          </FloatingButton>
        </Tooltip>
      </Fade>
    </ScrollContainer>
  );
};
